export const UserType = {
  STR_ACCOUNT_MANAGER: "ACCOUNT_MANAGER",
  STR_ACQUISITION: "ACQUISITION",
  STR_CUSTOMER: "CUSTOMER",
  STR_FINANCE: "FINANCE",
  STR_FINANCE_MANAGER: "FINANCE MANAGER",
  STR_FINANCE_SPECIALIST: "FINANCE SPECIALIST",
  STR_FINANCE_TREASURY_1: "FINANCE TREASURY 1",
  STR_FINANCE_TREASURY_2: "FINANCE TREASURY 2",
  STR_KAMS: "KAMS",
  STR_MALL_ADMIN: "MALL ADMIN",
  STR_MARKETING: "MARKETING",
  STR_OMI_ADMIN: "OMI ADMIN",
  STR_OMI_FINANCE: "OMI FINANCE",
  STR_OMI_OPS: "OMI OPS",
  STR_RIDER: "RIDER",
  STR_RUNNER: "RUNNER",
  STR_SELLER_MASTER: "SELLER MASTER",
  STR_STORE_ADMIN: "STORE ADMIN"
};

export const Permissions = {
  MANAGE_COUPONS: "MANAGE_COUPONS"
};
